module.exports = __webpack_public_path__ + "img/dibang.f389f10d.png";